const apiService = {
    getSocialLinks: async (siteId) => {
        try {
            const response =
                await fetch(`https://ayhansuleymanov-002-site1.ptempurl.com/api/sociallink/${siteId}`);
            if (!response.ok) {
                throw new Error("Failed to fetch data");
            }
            return await response.json();
        } catch (error){
            console.error(error);
            throw error;
        }
    },
}

export default apiService;
